const SUBSCRIPTION = (state, subscription) => {
  state.subscription = subscription;
};

const SUBSCRIPTION_STOPPED = state => {
  state.subscription.status = 'INACTIVE';
};

const SET_TARIFF = (state, tariff) => {
  state.tariff = tariff;
};

const SET_WRITE_OFF_OPTION = (state, option) => {
  state.writeOffOption = option;
};

export default {
  SUBSCRIPTION,
  SUBSCRIPTION_STOPPED,
  SET_TARIFF,
  SET_WRITE_OFF_OPTION,
};
